import styled from 'styled-components';
import { media } from '../../theme/breakpoints';
import theme from '../../theme/theme';

export const WorkspaceContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-height: 750px;

    ${media.md} {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
    }

    @media (min-width: 1600px) {
        flex-direction: row;
        align-items: center;
        gap: 20px;
    }
`;

export const ChatSection = styled.div<{ $panelOpen: boolean }>`
    flex: 1;
    display: flex;
    justify-content: center;
    transition: all 300ms ease;
    width: 100%;

    @media (min-width: 1600px) {
        width: ${props => props.$panelOpen ? 'calc(100% - 470px)' : '100%'};
    }
`;

export const PanelSection = styled.div<{ $isOpen: boolean }>`
    width: 100%;
    transition: all 300ms ease;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    @media (min-width: 1600px) {
        width: ${props => props.$isOpen ? '450px' : '0'};
        overflow: ${props => props.$isOpen ? 'visible' : 'hidden'};
    }
`;

export const ToggleButton = styled.button<{ $panelOpen: boolean }>`
    position: fixed;
    right: ${props => props.$panelOpen ? '450px' : '20px'};
    top: 50%;
    transform: translateY(-50%);
    z-index: 1000;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid rgba(224, 224, 224, 1);
    background-color: #fff;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    display: none;
    align-items: center;
    justify-content: center;
    transition: all 300ms ease;

    &:hover {
        border-color: ${theme.palette.primary.main};

        svg {
            opacity: 1;
        }
    }

    &:active {
        transform: translateY(-50%) scale(0.95);
    }

    svg {
        width: 20px;
        height: 20px;
        transition: transform 200ms ease, opacity 200ms ease;
        transform: rotate(${props => props.$panelOpen ? '180deg' : '0deg'});
        opacity: 0.7;
        
        path {
            fill: ${theme.palette.primary.main};
        }
    }

    @media (min-width: 1600px) {
        display: flex;
    }
`;
